import { URL_CONTROLLER_PROYECCION_HE, URL_SOLO_CONTROLLER_PROYECCION_HE } from "components/Admin/Horas Extras/Proyeccion Horas Extras/FunctionsProyeccionHorasExtras"
import { InformacionBusquedaUsuario, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json"
import { DetalleActividadProyHEDTO, DetalleModificacionProyeccionHEDTO, DetalleServidoresProyHEDTO, InformacionProyeccionHEDirectivoUnidad, InformacionServidoresOtrasUnidadesHEDTO, ProyeccionHistoricoHEDTO } from "./TypesProyeccionDirectivo";
import axios from "axios";
import { authHeader } from "helpers/auth-header";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import { InformacionGeneralProyeccionTH } from "components/Admin/Horas Extras/Proyeccion Horas Extras/TypesProyecionHorasExtrasAdmin";
import { DataActividadSave, DetalleServidorPlanHEDTO, SolicitudReversoDTO } from "../PlanificacionHE/TypesPlanificacionHE";
import { downloadExcelReport } from "../../../../helpers/downloadExcelReport";


const URL_INFORMACION_GENERAL_PROYECCION_DIRECTIVO = URL_CONTROLLER_PROYECCION_HE + "/InformacionGeneral/DirectivoUnidad"
const URL_DETALLE_PROYECCION_PERSONAL_UNIDAD = URL_CONTROLLER_PROYECCION_HE + "/DetalleProyeccionPersonal/DirectivoUnidad"
const URL_ASIGNAR_PERSONA_ACTIVIDAD = URL_CONTROLLER_PROYECCION_HE + "/ProyeccionbyActividad/DirectivoUnidad"
const URL_ASIGNAR_ACTIVIDAD_A_PERSONA = URL_CONTROLLER_PROYECCION_HE + "/ProyeccionbyServidor/DirectivoUnidad"

const URL_ELIMINAR_PROYECCION_ACTIVIDAD = URL_CONTROLLER_PROYECCION_HE + "/ProyeccionbyActividad"

const URL_EDITAR_PROYECCION_ACTIVIDAD = URL_CONTROLLER_PROYECCION_HE + "/EditarProyeccionbyActividad"


const URL_BUSCAR_SERVIDOR_CEDULA = URL_CONTROLLER_PROYECCION_HE + "/InformacionUsuarioProyeccionHE"

const URL_BUSCAR_SERVIDOR_NOMBREAPELLIDO = URL_CONTROLLER_PROYECCION_HE + "/InformacionUsuarioProyeccionHE"

const URL_INFORMACION_SERVIDOR_HE = URL_CONTROLLER_PROYECCION_HE + "/DetalleServidorHE"


const URL_GUARDADO_PARCIAL_PROYECCION = URL_CONTROLLER_PROYECCION_HE + "/GuardarProyeccionParcialmente"

const URL_ENVIAR_PROYECCION_TH = URL_CONTROLLER_PROYECCION_HE + "/GuardarProyeccionUnidad"

const URL_SOLICITAR_REVERSO_PROYECCION_UNIDAD = URL_CONTROLLER_PROYECCION_HE + "/SolicitudReversoProyeccion"

const URL_REPORTE_EXCEL_RESUMEN_PROYECCION = URL_SOLO_CONTROLLER_PROYECCION_HE + "/ReporteExcelProyeccion"

const URL_CONSULTAR_HISTORIAL_PROYECCIONES = URL_CONTROLLER_PROYECCION_HE + "/HistoricoProyeccionHorasExtras"
const URL_CONSULTAR_PROYECCION_OTRO_ANIO = URL_CONTROLLER_PROYECCION_HE + "/InformacionGeneral/DirectivoUnidad" 
export async function ObtenerInformacionProyeccionDirectivoHE() {
    var respuesta: ResponseRequestGeneric<InformacionProyeccionHEDirectivoUnidad|string> = {
        status: -1
    };

    try {

        const responseAxios = await axios.get(URL_INFORMACION_GENERAL_PROYECCION_DIRECTIVO, {
            headers: authHeader()
        })

        var data: InformacionProyeccionHEDirectivoUnidad|string = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionProyeccionHEDirectivoUnidad|string>(error)
    }

    return respuesta
}

export async function ObtenerInformacionProyeccionDirectivoByAnio(anio:number){
    const URL_COMPLETA = URL_CONSULTAR_PROYECCION_OTRO_ANIO + "/" + anio
    

    var respuesta: ResponseRequestGeneric<InformacionProyeccionHEDirectivoUnidad|string> = {
        status: -1
    };

    try {

        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: InformacionProyeccionHEDirectivoUnidad|string = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionProyeccionHEDirectivoUnidad|string>(error)
    }

    return respuesta
}

export async function ObtenerDetalleProyeccionPersonalDirectivoUnidad() {
    var respuesta: ResponseRequestGeneric<DetalleModificacionProyeccionHEDTO> = {
        status: -1
    };

    try {

        const responseAxios = await axios.get(URL_DETALLE_PROYECCION_PERSONAL_UNIDAD, {
            headers: authHeader()
        })

        var data: DetalleModificacionProyeccionHEDTO = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleModificacionProyeccionHEDTO>(error)
    }

    return respuesta


}

export async function GuardarProyeccionbyActividad(proyeccion: DataActividadSave) {

    var respuesta: ResponseRequestGeneric<DetalleActividadProyHEDTO[]> = {
        status: -1
    };

    try {

        const responseAxios = await axios.post(URL_ASIGNAR_PERSONA_ACTIVIDAD, proyeccion, {
            headers: authHeader()
        })

        var data: DetalleActividadProyHEDTO[] = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleActividadProyHEDTO[]>(error)
    }

    return respuesta

}

export async function GuardarProyeccionbyServidor(proyeccion: DetalleServidorPlanHEDTO) {

    var respuesta: ResponseRequestGeneric<DetalleServidoresProyHEDTO[]> = {
        status: -1
    };

    try {

        const responseAxios = await axios.post(URL_ASIGNAR_ACTIVIDAD_A_PERSONA, proyeccion, {
            headers: authHeader()
        })

        var data: DetalleServidoresProyHEDTO[] = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleServidoresProyHEDTO[]>(error)
    }

    return respuesta

}


export async function EliminarProyeccionbyActividad(idActividad: number) {

    var respuesta: ResponseRequestGeneric<DetalleActividadProyHEDTO[]> = {
        status: -1
    };

    try {

        const URL_COMPLETA = URL_ELIMINAR_PROYECCION_ACTIVIDAD + "/" + idActividad
        const responseAxios = await axios.delete(URL_COMPLETA, {
            headers: authHeader()
        })

        var data: DetalleActividadProyHEDTO[] = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleActividadProyHEDTO[]>(error)
    }

    return respuesta

}


export async function EditarProyeccionbyActividad(proyeccion: DataActividadSave) {

    var respuesta: ResponseRequestGeneric<DetalleActividadProyHEDTO[]> = {
        status: -1
    };

    try {

        const URL_COMPLETA = URL_EDITAR_PROYECCION_ACTIVIDAD
        const responseAxios = await axios.post(URL_COMPLETA, proyeccion, {
            headers: authHeader()
        })

        var data: DetalleActividadProyHEDTO[] = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleActividadProyHEDTO[]>(error)
    }

    return respuesta
}

export async function BuscarInformacionPersonaByIdentificacion(identificacion: string) {
    var respuesta: ResponseRequestGeneric<InformacionBusquedaUsuario | null> = {
        status: -1
    };

    try {

        const URL_COMPLETA = URL_BUSCAR_SERVIDOR_CEDULA + "/" + identificacion
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })

        var data: InformacionBusquedaUsuario | null = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionBusquedaUsuario | null>(error)
    }

    return respuesta
}

export async function BuscarInformacionPersonaByNombreApellido(nombreapellido: string) {
    var respuesta: ResponseRequestGeneric<InformacionBusquedaUsuario[]> = {
        status: -1
    };

    try {

        const responseAxios = await axios.get(URL_BUSCAR_SERVIDOR_NOMBREAPELLIDO, {
            params: {
                nombreapellido: nombreapellido
            },
            headers: authHeader()
        })

        var data: InformacionBusquedaUsuario[] = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionBusquedaUsuario[]>(error)
    }

    return respuesta
}

export async function ObtenerInformacionServidorHE(identificacion: string) {
    var respuesta: ResponseRequestGeneric<DetalleServidoresProyHEDTO> = {
        status: -1
    };

    try {
        const URL_COMPLETA = URL_INFORMACION_SERVIDOR_HE + "/" + identificacion
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })

        var data: DetalleServidoresProyHEDTO = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleServidoresProyHEDTO>(error)
    }

    return respuesta
}

export async function GuardarProyeccionParcialmente(proyeccion: DetalleServidoresProyHEDTO[]) {
    var respuesta: ResponseRequestGeneric<DetalleServidoresProyHEDTO> = {
        status: -1
    };

    try {
        const responseAxios = await axios.post(URL_GUARDADO_PARCIAL_PROYECCION, proyeccion,{
            headers: authHeader()
        })

        var data: DetalleServidoresProyHEDTO = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleServidoresProyHEDTO>(error)
    }

    return respuesta

}

export async function GuardarEnviarProyeccionTH(proyeccion: DetalleServidoresProyHEDTO[]) {
    var respuesta: ResponseRequestGeneric<DetalleServidoresProyHEDTO> = {
        status: -1
    };

    try {
        const responseAxios = await axios.post(URL_ENVIAR_PROYECCION_TH, proyeccion,{
            headers: authHeader()
        })

        var data: DetalleServidoresProyHEDTO = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleServidoresProyHEDTO>(error)
    }

    return respuesta

}

export async function SolicitarReversoProyeccion(idProyeccionUnidad:number,informacion:SolicitudReversoDTO){
    const URL_COMPLETA = URL_SOLICITAR_REVERSO_PROYECCION_UNIDAD + "/" + idProyeccionUnidad

    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {
        const responseAxios = await axios.post(URL_COMPLETA, informacion,{
            headers: authHeader()
        })



        respuesta = {
            status: responseAxios.status
            
        }
    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }

    return respuesta

}


export async function ObtenerReporteExcelResumenProyeccionTH() {

    const URLCOMPLETA = `${URL_REPORTE_EXCEL_RESUMEN_PROYECCION}`
    await downloadExcelReport(URLCOMPLETA, "REPORTE PROYECCION UNIDAD.xlsx")
}

export async function ObtenerDetalleHistoricoProyeccion() {
    var respuesta: ResponseRequestGeneric<ProyeccionHistoricoHEDTO[]|string> = {
        status: -1
    };

    try {

        const responseAxios = await axios.get(URL_CONSULTAR_HISTORIAL_PROYECCIONES, {
            headers: authHeader()
        })

        var data: ProyeccionHistoricoHEDTO[]|string = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<ProyeccionHistoricoHEDTO[]|string>(error)
    }

    return respuesta


}



